import styled from "styled-components";

export const Container = styled.div`
    background-color: ${({ theme }) => theme.colors.primary};
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    justify-content: flex-start;
    align-items: center;
    min-height: 100vh;
`;

export const TendbeLogo = styled.a`
    height: 45px;
    width: 45px;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: transparent;
    background-image: url("/images/tb-icon.png");
    @media (min-width: 768px) {
        margin-left: 10px;
        width: 120px;
        background-image: url("/images/tb-logo.png");
    }
`;

export const UserContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const SideIcon = styled.img`
    height: 20px;
    width: 20px;
    margin-top: -10px;
`;

export const UserName = styled.span`
    font-size: 12px;
    margin-top: 3px;
    max-width: 80px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
